import script from "./ExamRegistration2.vue?vue&type=script&setup=true&lang=js"
export * from "./ExamRegistration2.vue?vue&type=script&setup=true&lang=js"

import "./ExamRegistration2.vue?vue&type=style&index=0&id=4a93f01b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a93f01b"]])

export default __exports__